import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { isEqual, flattenDeep } from 'lodash';
import React, { useMemo } from 'react';
import { encodeSelections } from '@/utils/widget/parseSelections';
import useSelections from '@/components/widget/misc/useSelections';
import useSubscribeWidgetResults from '@/components/widget/visualizations/hooks/useSubscribeWidgetResults';
import { getSelectionGroupItemByIndex } from '@/components/Editor/Form/utils';
import { useRadarStyles } from '@/components/widget/visualizations/RadarChart/stylesTheme';
import { DEFAULT_COLORS, selectionConfig, useData } from '@/components/widget/visualizations/RadarChart';
import { DEFAULT_DATA_LABEL_OPTIONS } from '@/components/widget/visualizations/RadarChart/utils';
import LineStyles from '@/components/Editor/Form/fields/LineStyles';
import RevealPill from '@/components/Editor/Form/fields/RevealPill';
import ColorPalletMenu from '@/components/Editor/Form/fields/ColorPalletMenu';
import Headings from '@/components/Editor/Form/fields/Headings';
import DataLabels from '@/components/Editor/Form/fields/DataLabels';
import Legend from '@/components/Editor/Form/fields/Legend';
import Animation from '@/components/Editor/Form/fields/Animation';
import ChartLabels from '@/components/Editor/Form/fields/ChartLabels';
import Collapsible from '@/components/Editor/Form/fields/common/Collapsible';
import PointStyles, { checkPointStylesModified } from '@/components/Editor/Form/fields/PointStyles';
import { TemplateRevealPill } from '@/components/Editor/Form/fields/Template';
import { disabledPointStyles } from './settings';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PaintBrushIcon = function PaintBrushIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_7929_813)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M6.66852 13.5403L4.67137 16.7957C3.8191 18.1849 1.89246 18.4124 0.740017 17.26C-0.412421 16.1076 -0.184885 14.1809 1.20431 13.3287L4.45968 11.3315C4.73521 11.1625 4.78034 10.7803 4.55177 10.5518L3.41422 9.41421C2.63317 8.63317 2.63317 7.36683 3.41422 6.58578L5.50001 4.5L13.5 12.5L11.4142 14.5858C10.6332 15.3668 9.36685 15.3668 8.5858 14.5858L7.44826 13.4482C7.21969 13.2197 6.83756 13.2648 6.66852 13.5403Z",
        fill: "black"
      }), /*#__PURE__*/_jsx("path", {
        d: "M13.5 12.5001L5.5 4.50012L9.11871 0.881563C10.2903 -0.289952 12.1897 -0.289948 13.3613 0.881575L17.1186 4.6388C18.2902 5.81036 18.2902 7.70988 17.1186 8.88147L13.5 12.5001Z",
        fill: "#C3C9D1"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_7929_813",
        children: /*#__PURE__*/_jsx("rect", {
          width: "18",
          height: "18",
          fill: "white"
        })
      })
    })]
  }));
};

PaintBrushIcon.defaultProps = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const WidgetEditFormRadarChartFields = _ref => {
  var _config$globalSeriesO3, _config$globalSeriesO4, _config$globalSeriesO5, _config$globalSeriesO6, _config$globalSeriesO7, _config$globalSeriesO8, _config$globalSeriesO9, _config$globalSeriesO10, _globalSeriesOptions$, _globalSeriesOptions$2, _globalSeriesOptions$3, _globalSeriesOptions$4, _globalSeriesOptions$5, _globalSeriesOptions$6;

  let {
    widgetId,
    sectionId,
    reportingWidgetId,
    config,
    pillVariant,
    onChange,
    onEditSelections
  } = _ref;
  const nameSpace = `radar-chart-${widgetId}-${sectionId}`;
  const templateFieldId = `${nameSpace}-template`;
  const {
    themeStyles,
    defaultStyles
  } = useRadarStyles(config);
  const {
    selections,
    labelsSelections = '',
    selectionsLabeled = false,
    colorPallet = DEFAULT_COLORS,
    globalSeriesOptions,
    seriesOptions = [],
    collectionOptions = [],
    selectionsStrategy = 'default'
  } = config; // Get current selection results

  const results = useSubscribeWidgetResults(reportingWidgetId); // Apply selections to results

  const {
    selectionResults
  } = useSelections({
    results,
    selections: selections || '',
    selectionsLabeled,
    selectionConfig
  }); // Combine results with rendering styles

  const {
    chartData
  } = useData({
    results: selectionResults,
    globalSeriesOptions: globalSeriesOptions || {},
    seriesOptions,
    collectionOptions,
    colorPallet,
    selectionsStrategy,
    themeStyles
  }); // Check if point styles have been modified

  const isPointStylesModified = useMemo(() => checkPointStylesModified(config.globalSeriesOptions || {}), [config.globalSeriesOptions]); // Check if line styles have been modified

  const isLineStylesModified = useMemo(() => ['lineWidth', 'lineDash', 'lineColor', 'lineBackgroundColor'].some(key => {
    var _config$globalSeriesO, _config$globalSeriesO2;

    return ((_config$globalSeriesO = config.globalSeriesOptions) === null || _config$globalSeriesO === void 0 ? void 0 : _config$globalSeriesO[key]) !== undefined && !isEqual((_config$globalSeriesO2 = config.globalSeriesOptions) === null || _config$globalSeriesO2 === void 0 ? void 0 : _config$globalSeriesO2[key], defaultStyles[key]);
  }), [config.globalSeriesOptions, defaultStyles]);
  const exampleValue = useMemo(() => {
    const exampleSelection = getSelectionGroupItemByIndex(flattenDeep(selectionResults), 0);
    return typeof exampleSelection.value !== 'undefined' ? exampleSelection.value : 10;
  }, [selectionResults]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ColorPalletMenu, {
      label: "Colors",
      colors: colorPallet,
      palletColorOverrides: config.palletColorOverrides,
      openButtonVariant: pillVariant,
      onOverridePalletColors: (name, colors) => onChange('palletColorOverrides', {
        [name]: colors
      }),
      onChange: colorPallet => onChange('', {
        colorPallet
      })
    }), /*#__PURE__*/_jsx(RevealPill, {
      label: "Line Styles",
      variant: isLineStylesModified ? 'active' : '',
      openButtonVariant: pillVariant,
      activeState: /*#__PURE__*/_jsx(PaintBrushIcon, {}),
      children: /*#__PURE__*/_jsx(LineStyles, {
        nameSpace: nameSpace,
        lineDash: (_config$globalSeriesO3 = config.globalSeriesOptions) === null || _config$globalSeriesO3 === void 0 ? void 0 : _config$globalSeriesO3.lineDash,
        lineWidth: (_config$globalSeriesO4 = config.globalSeriesOptions) === null || _config$globalSeriesO4 === void 0 ? void 0 : _config$globalSeriesO4.lineWidth,
        lineColor: (_config$globalSeriesO5 = config.globalSeriesOptions) === null || _config$globalSeriesO5 === void 0 ? void 0 : _config$globalSeriesO5.lineColor,
        lineBackgroundColor: (_config$globalSeriesO6 = config.globalSeriesOptions) === null || _config$globalSeriesO6 === void 0 ? void 0 : _config$globalSeriesO6.lineBackgroundColor,
        colorPallet: colorPallet,
        enableGradientPicker: false,
        defaults: {
          lineWidth: defaultStyles.lineWidth,
          lineDash: defaultStyles.lineDash
        },
        onChange: update => onChange('globalSeriesOptions', update)
      }, nameSpace)
    }), /*#__PURE__*/_jsx(PointStyles, {
      variant: isPointStylesModified ? 'active' : '',
      nameSpace: nameSpace,
      pointRadius: ((_config$globalSeriesO7 = config.globalSeriesOptions) === null || _config$globalSeriesO7 === void 0 ? void 0 : _config$globalSeriesO7.pointRadius) ?? themeStyles.pointRadius,
      pointStyle: (_config$globalSeriesO8 = config.globalSeriesOptions) === null || _config$globalSeriesO8 === void 0 ? void 0 : _config$globalSeriesO8.pointStyle,
      pointBackgroundColor: (_config$globalSeriesO9 = config.globalSeriesOptions) === null || _config$globalSeriesO9 === void 0 ? void 0 : _config$globalSeriesO9.pointBackgroundColor,
      disabledPointStyles: disabledPointStyles,
      openButtonVariant: pillVariant,
      onChange: update => onChange('globalSeriesOptions', update)
    }, nameSpace), onEditSelections ? /*#__PURE__*/_jsx(ChartLabels, {
      nameSpace: nameSpace,
      selections: labelsSelections ? encodeSelections(labelsSelections || []) : undefined,
      defaultSelections: config.defaultLabelsSelections,
      openButtonVariant: pillVariant,
      onChange: onChange,
      onEditSelections: () => onEditSelections('labels')
    }) : /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsx(TemplateRevealPill, {
      id: templateFieldId,
      label: "Number Format",
      exampleValue: exampleValue,
      template: (_config$globalSeriesO10 = config.globalSeriesOptions) === null || _config$globalSeriesO10 === void 0 ? void 0 : _config$globalSeriesO10.template,
      openButtonVariant: pillVariant,
      onChange: value => onChange('globalSeriesOptions', {
        template: value
      })
    }), /*#__PURE__*/_jsx(Headings, {
      nameSpace: nameSpace,
      widgetId: widgetId,
      sectionId: sectionId,
      hasHeading: config.hasHeading,
      openButtonVariant: pillVariant,
      onChange: updates => onChange('', updates)
    }), /*#__PURE__*/_jsx(Legend, _objectSpread({
      nameSpace: nameSpace,
      legendPosition: config.legendPosition,
      legends: config.legends,
      hasLegend: config.hasLegend ?? false,
      legendsCount: chartData.legendsCount,
      hasLegendInputs: true,
      openButtonVariant: pillVariant,
      onChange: updates => onChange('', updates)
    }, onEditSelections && {
      onEditSelections: () => onEditSelections('legends')
    })), /*#__PURE__*/_jsx(DataLabels, {
      nameSpace: nameSpace,
      exampleValue: exampleValue,
      display: globalSeriesOptions === null || globalSeriesOptions === void 0 ? void 0 : (_globalSeriesOptions$ = globalSeriesOptions.dataLabels) === null || _globalSeriesOptions$ === void 0 ? void 0 : _globalSeriesOptions$.display,
      anchoring: globalSeriesOptions === null || globalSeriesOptions === void 0 ? void 0 : (_globalSeriesOptions$2 = globalSeriesOptions.dataLabels) === null || _globalSeriesOptions$2 === void 0 ? void 0 : _globalSeriesOptions$2.anchoring,
      alignment: globalSeriesOptions === null || globalSeriesOptions === void 0 ? void 0 : (_globalSeriesOptions$3 = globalSeriesOptions.dataLabels) === null || _globalSeriesOptions$3 === void 0 ? void 0 : _globalSeriesOptions$3.alignment,
      rotation: globalSeriesOptions === null || globalSeriesOptions === void 0 ? void 0 : (_globalSeriesOptions$4 = globalSeriesOptions.dataLabels) === null || _globalSeriesOptions$4 === void 0 ? void 0 : _globalSeriesOptions$4.rotation,
      template: globalSeriesOptions === null || globalSeriesOptions === void 0 ? void 0 : (_globalSeriesOptions$5 = globalSeriesOptions.dataLabels) === null || _globalSeriesOptions$5 === void 0 ? void 0 : _globalSeriesOptions$5.template,
      color: globalSeriesOptions === null || globalSeriesOptions === void 0 ? void 0 : (_globalSeriesOptions$6 = globalSeriesOptions.dataLabels) === null || _globalSeriesOptions$6 === void 0 ? void 0 : _globalSeriesOptions$6.color,
      colorPallet: colorPallet,
      defaults: {
        color: defaultStyles === null || defaultStyles === void 0 ? void 0 : defaultStyles.chartDataLabelColor,
        alignment: DEFAULT_DATA_LABEL_OPTIONS.align,
        anchoring: DEFAULT_DATA_LABEL_OPTIONS.anchor
      },
      openButtonVariant: pillVariant,
      onChange: update => onChange('globalSeriesOptions', {
        dataLabels: _objectSpread(_objectSpread({}, globalSeriesOptions === null || globalSeriesOptions === void 0 ? void 0 : globalSeriesOptions.dataLabels), update)
      })
    }), /*#__PURE__*/_jsx(Animation, {
      nameSpace: nameSpace,
      animation: config.animation,
      openButtonVariant: pillVariant,
      onChange: update => onChange('animation', update)
    }), /*#__PURE__*/_jsx(Collapsible, {
      nameSpace: nameSpace,
      collapsible: globalSeriesOptions === null || globalSeriesOptions === void 0 ? void 0 : globalSeriesOptions.collapsible,
      openButtonVariant: pillVariant,
      onChange: update => onChange('globalSeriesOptions', update)
    })]
  });
};

export default WidgetEditFormRadarChartFields;